











































































import { Component, Vue } from 'vue-property-decorator';
   @Component({ 
    })


export default class AddBankAccount extends Vue   {

 dialog:boolean= true;

  data () {
      return {

        banksItems:['Garanti','Vakıfbank','İş Bankası'],
        banks: [],

        citiesItems:['Antalya','İstanbul','Moscow',],
        cities: [],
      }
    }
 

    closeDialog(){
      this.$emit('closed');
     
    }



};
